import {Injectable} from '@angular/core';
import {Http, ResponseContentType} from "@angular/http";

import * as FileSaver from 'file-saver';

@Injectable()
export class FileDownloadService {

    private api_purchase_order = './api/mpdf/server/purchase_order-report.php';
    private api_inventaire = './api/mpdf/server/stocktraking-report.php';
    private api_docket = './api/mpdf/server/docket-report.php';
    private api_enter_docket = './api/mpdf/server/enter_docket.php';
    private api_issue_docket = './api/mpdf/server/issue_docket.php';
    private api_initial_stock = './api/mpdf/server/initial_stock.php';

    constructor(private http: Http) {}

    downloadFile(rapport: any) {
        this.http.get(this.api_inventaire
            + '?id_rapport=' + rapport.id_stocktaking, {
                responseType: ResponseContentType.Blob
            })
            .subscribe((response: any) => {
                FileSaver.saveAs(response.blob(), 'rapport_' + rapport.reference + "_" + rapport.date + '.pdf');
            });
    }

    PurchaseOrder(bcf: any) {
        var reference = bcf.reference.split('_')[0];
        var id = 0;
        if(reference === "BRF"){
            id = bcf.antecedent;
            console.log('antecedent');
        }else{
            id = bcf.id_purchase_order;
            console.log('normal');
        }
        this.http.get(this.api_purchase_order
         + '?id_purchase_order=' + id, {
//            + '?id_purchase_order=' + bcf.id_purchase_order, {
                responseType: ResponseContentType.Blob
            })
            .subscribe((response: any) => {
                FileSaver.saveAs(response.blob(), bcf.supplier + '_' + bcf.date + '.pdf');
            });
    }


    EnterDocket(numero: any, date: any, name: string) {
        this.http.get(this.api_enter_docket
            + '?numero=' + numero + '&date=' + date + '&name=' + name
            , {
                responseType: ResponseContentType.Blob
            })
            .subscribe((response: any) => {
                FileSaver.saveAs(response.blob(), 'Bordereau d\' Entrée_' + numero + '.pdf');
            });
    }

    IssueDocket(numero: any, date: any, name: string) {
        this.http.get(this.api_issue_docket
            + '?numero=' + numero + '&date=' + date + '&name=' + name
            , {
                responseType: ResponseContentType.Blob
            })
            .subscribe((response: any) => {
                FileSaver.saveAs(response.blob(), 'Bordereau de Sortie_' + numero + '.pdf');
            });
    }

    InitialStock(name: string, numero: any, date: any) {
        this.http.get(this.api_initial_stock
            + '?numero=' + numero + '&date=' + date + '&name=' + name
            , {
                responseType: ResponseContentType.Blob
            })
            .subscribe((response: any) => {
                FileSaver.saveAs(response.blob(), 'Stock Initial(Entrée)_' + numero + '.pdf');
            });
    }

    DocketPdf(docket: any) {
        this.http.get(this.api_docket
            + '?id_docket=' + docket.id_docket + '&date=' + docket.timestamp + '&operation=' + docket.operation, {
                responseType: ResponseContentType.Blob
            })
            .subscribe((response: any) => {
                FileSaver.saveAs(response.blob(), 'BordereauRéf_' + docket.reference_code + '_' + docket.timestamp + '.pdf');
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/file-download.service.ts